import api from '../../api/v2/api'
import UserInquiryForm from '../../api/v2/forms/user_inquiry'

class UserInquiryState {
  async create(userInquiryForm: UserInquiryForm){
    return await api.inquiry.create(userInquiryForm)
  }
  async update(inquiryId: number, userInquiryForm: UserInquiryForm){
    return await api.inquiry.update(inquiryId, userInquiryForm)
  }
}

export const userInquiryState = new UserInquiryState()
